'use client';

import { AppleIcon } from '@curology/ui-components-web/react/Icon/icons/AppleIcon';
import { FacebookIcon } from '@curology/ui-components-web/react/Icon/icons/FacebookIcon';
import { GoogleIcon } from '@curology/ui-components-web/react/Icon/icons/GoogleIcon';
import clsx from 'clsx';

import { Typography } from '@/components/squeeze';
import { useUserAgent } from '@/hooks/useUserAgent';
import { urls } from '@/utils/urls';

import { useFlowContext } from '../../hooks/useFlowContext';
import { useFlowCurrentStepUrl } from '../../hooks/useFlowCurrentStepUrl';
import { useFlowUrl } from '../../hooks/useFlowUrl';

const classes =
  'cur-flex cur-items-center cur-justify-center cur-h-12 cur-w-12 cur-rounded-full';

export const SocialSignupButtons = () => {
  const { brand } = useFlowContext();
  const { isEmbeddedWebView } = useUserAgent();
  const flowUrl = useFlowUrl();
  const currentUrl = useFlowCurrentStepUrl();

  return (
    <>
      <div className="cur-w-full cur-flex cur-items-center">
        <div className="cur-flex-grow cur-border-t cur-border-border-secondary" />
        <Typography className="cur-flex-shrink cur-mx-4 cur-text-primary">
          sign up with social
        </Typography>
        <div className="cur-flex-grow cur-border-t cur-border-border-secondary" />
      </div>
      <div className="cur-flex cur-justify-center cur-gap-4 cur-my-2">
        <a
          className={clsx(classes, '!cur-text-inverse cur-bg-[#3b5998]')}
          href={urls[brand].api.accountCreation.getProvider(
            'facebook',
            flowUrl,
            currentUrl,
          )}
        >
          <FacebookIcon className="cur-h-4" />
        </a>
        <a
          className={clsx(classes, '!cur-text-inverse cur-bg-[#000]')}
          href={urls[brand].api.accountCreation.getProvider(
            'apple',
            flowUrl,
            currentUrl,
          )}
        >
          <AppleIcon className="cur-h-4" />
        </a>
        {!isEmbeddedWebView && (
          <a
            className={clsx(
              classes,
              'cur-border-2 cur-border-[#000000] cur-bg-[#FFFFFF]',
            )}
            href={urls[brand].api.accountCreation.getProvider(
              'google',
              flowUrl,
              currentUrl,
            )}
          >
            <GoogleIcon className="cur-h-4 cur-m-auto" />
          </a>
        )}
      </div>
    </>
  );
};
